// removed by extract-text-webpack-plugin
module.exports = {"address-list-item":"_1ypNvqyMxKqXcsDH4SnFvH","address-row":"FcU67PxegUHp3MVzyFPb8","column-radio":"_2XYV84ULTiXgqiv2ovFp5a","column-address":"_2GLYBhfM__-uO7eYJGr2__","column-options":"_1bUDskhsdK8HzdD1DT-LC7","column-options__option":"_2afnSj06GREdjCdV-LLmN6","li-option":"_3B7PxpEig_nj3NSXjUAEKC"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressBook/components/AddressListItem/style.scss
// module id = 859
// module chunks = 0